module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-700-d1d7b85dc76bad1a967fc842d110262c.woff";